import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const sharedCssDisabled = css`
  cursor: not-allowed;
  background-color: ${({ theme }) => theme.colors.gray100};
  color: ${({ theme }) => theme.colors.gray200};
  &:hover {
    background-color: ${({ theme }) => theme.colors.gray100};
    color: ${({ theme }) => theme.colors.gray200};
  }
`;

const ButtonContainer = styled.button`
  display: block;
  background-color: ${({ theme }) => theme.colors.institucional};
  text-align: center;
  width: 100%;
  border: 0;
  padding: 14px;
  font-weight: 600;
  color: #fff;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.2s;
  &:hover {
    background-color: ${({ theme }) => theme.colors.institucionalLight};
  }
  &.disabled {
    ${sharedCssDisabled}
  }
  ${({ disabled }) => disabled && sharedCssDisabled}
`;

function Button({ children, ...rest }) {
  return <ButtonContainer {...rest}>{children}</ButtonContainer>;
}

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
};

export default Button;
